import { useTranslation } from "react-i18next";
import {
  CaretDownOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Flex,
  Image,
  Menu,
  message,
  Modal,
  Row,
  Typography,
  Upload,
} from "antd";
import { toNumber } from "lodash";
import React, { useEffect, useState } from "react";
import { useAddLesson } from "../../../../../../stores/stores";
import { ListTypeQuestion, ModeQuestion } from "../../../../../../constants";
import { FileType } from "../../../../../../utils/uploadImage";
import { uploadFileMoodleQuiz } from "../../../../../../service/course-construct";
import { renderQuestionNameByType } from "../../../../../../utils/functionUltils";
import { QuizInfoInBank } from "../../../../../../types/question-bank";
import { useParams } from "react-router-dom";
import { convertLatexToImage, stripHtml } from "../../../../../../utils/app";
import useKeyword from "../../../../../../hooks/useKeyword";
import { useDirty } from "../../../../../../contexts/DirtyProvider";

interface AddQuestionSidebarProps {
  loadingDetail?: boolean;
  quizzes: QuizInfoInBank[];
  onRefresh?: () => void;
  setLoading?: (value: boolean) => void;
}

function AddQuestionSidebar({
  quizzes,
  loadingDetail,
  onRefresh = () => {},
  setLoading = () => {},
}: AddQuestionSidebarProps) {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const {
    currentIdQuestionAdd,
    setModeQuestion,
    setQuestion,
    setTypeQuestionChoose,
    setQuestionSettingsBe,
    setCurrentQuestionInfo,
  } = useAddLesson();
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [activeType, setActiveType] = useState(0);
  const params = useParams();
  const bankId = toNumber(params?.id);
  const { setDirty } = useDirty();
  const currentQuizEditInBank = useKeyword("quizId");

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClick = (item: any) => {
    setDirty(false);
    const clickItem = quizzes?.find(
      (itm: any) => itm?.id === toNumber(item?.key)
    );

    if (clickItem) {
      setSelectedKeys([`${item?.key}`]);
      setQuestion(clickItem);
      setModeQuestion(ModeQuestion.UPDATE);
    }
  };

  useEffect(() => {
    if (currentIdQuestionAdd) {
      setSelectedKeys([`${currentIdQuestionAdd}`]);
    }
  }, [currentIdQuestionAdd]);

  useEffect(() => {
    if (currentQuizEditInBank) {
      setSelectedKeys([`${currentQuizEditInBank}`]);
    }
  }, [currentQuizEditInBank]);

  const confirmCreateQuestion = (type: number) => {
    setActiveType(type);
    setOpenAddModal(false);
    setTypeQuestionChoose(type);
    setQuestionSettingsBe({});
    setCurrentQuestionInfo({});
    setQuestion({});
    setDirty(true);
    setTimeout(() => {
      setModeQuestion(ModeQuestion.CREATE);
      setQuestion(
        new Object({
          type: type,
          question: renderQuestionNameByType(type),
        })
      );
    }, 1);
  };

  const items: any = quizzes?.map((item: any, pIndex: number) => ({
    key: `${item.id}`,
    label: (
      <div className="font-weight-5 one-line">
        {collapsed ? (
          `${pIndex + 1}`
        ) : (
          <div
            className="flex question-col"
            style={{ alignItems: "center", padding: "0.5rem 0" }}
          >
            <span style={{ width: "10%" }}>{pIndex + 1}.</span>
            <div
              className="question-content"
              dangerouslySetInnerHTML={{
                __html: `${convertLatexToImage(item.question)}`,
              }}
            ></div>
          </div>
        )}
      </div>
    ),
  }));

  const handleBeforeUpload = (file: FileType) => {
    const isXMLFile = file.type === "text/xml";
    if (!isXMLFile) {
      message.error(t("Bạn phải tải lên file XML !", "Bạn phải tải lên file XML !"));
    }
    return isXMLFile;
  };

  const handleCustomRequestUpload = async (options: any) => {
    const file = options.file;
    if (file.type === "text/xml") {
      const formData = new FormData();
      formData.append("questionBankId", JSON.stringify(bankId));
      formData.append("xmlFile", file);
      setLoading(true);
      await uploadFileMoodleQuiz(formData).then((res) => {
        if (res.status === 200) {
          Modal.confirm({
            title: `Thông báo`,
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            content: (
              <Flex className="center" align="center" justify="center" vertical>
                <p className="text-16 text-green">{t("Thực hiện thành công !", "Thực hiện thành công !")}</p>
                <span>
                  {t("Đã tải lên", "Đã tải lên")}{" "}
                  <span className="font-weight-5">
                    {res.data.data.totalQuestionsSuccess}
                  </span>
                  /
                  <span className="font-weight-5">
                    {res.data.data.totalQuestionsInFile}
                  </span>{" "}
                  {t("câu hỏi", "câu hỏi")}
                </span>
              </Flex>
            ),
            centered: true,
            okText: t("Xác nhận", "Xác nhận"),
            footer: (_, { OkBtn }) => (
              <>
                <OkBtn />
              </>
            ),
          });
          // message.success(
          //   `${res.data.message}, đã tải lên ${res.data.data.totalQuestionsSuccess}/${res.data.data.totalQuestionsInFile} câu hỏi`,
          //   3
          // );
          setLoading(false);
          onRefresh();
        }
      });
    }
  };

  return (
    <div
      className={`add-quest-sidebar ${
        collapsed ? "add-quest-sidebar-hidden" : ""
      } `}
    >
      <Flex
        justify={collapsed ? "center" : "space-between"}
        align="center"
        className="sidebar-title"
      >
        {!collapsed && (
          <span className="font-size-16">
            <span className="font-weight-5 ml-2">
              {t("Danh sách câu hỏi (", "Danh sách câu hỏi (")}{items ? items.length : "0"})
            </span>
          </span>
        )}

        <div className="toggle-btn" onClick={toggleCollapsed}>
          {collapsed ? (
            <MenuUnfoldOutlined style={{ fontSize: 16 }} />
          ) : (
            <MenuFoldOutlined style={{ fontSize: 16 }} />
          )}
        </div>
      </Flex>
      <div className="sidebar-quest-list">
        <Menu
          defaultActiveFirst
          selectedKeys={selectedKeys}
          defaultOpenKeys={["0"]}
          mode="inline"
          onClick={handleMenuClick}
          disabled={loadingDetail ? loadingDetail : false}
          inlineCollapsed={collapsed}
          expandIcon={({ isOpen }) =>
            isOpen ? (
              <div className="expand-icon open">
                <CaretDownOutlined />
              </div>
            ) : (
              <div className="expand-icon close">
                <CaretDownOutlined />
              </div>
            )
          }
          items={items}
        />
      </div>
      <Flex
        className="sidebar-btn-group pl-1 pr-1 pb-2"
        vertical
        justify="center"
        align="center"
      >
        <Button
          className="w-full"
          icon={<PlusOutlined />}
          onClick={() => setOpenAddModal(true)}
        >
          {!collapsed ? t("Thêm câu hỏi", "Thêm câu hỏi") : ""}
        </Button>

        <Upload
          showUploadList={false}
          accept=".xml"
          beforeUpload={handleBeforeUpload}
          customRequest={(options) => handleCustomRequestUpload(options)}
        >
          <Button className="w-full btn-primary mt-1" icon={<UploadOutlined />}>
            {!collapsed ? t(" Tải file .xml", " Tải file .xml") : ""}
          </Button>
        </Upload>
      </Flex>

      <Modal
        className="add-type-question-modal"
        title={
          <>
            <Typography.Title level={5}>{t("Thêm câu hỏi", "Thêm câu hỏi")}</Typography.Title>
          </>
        }
        closeIcon={<CloseOutlined />}
        centered
        open={openAddModal}
        okText={t("Đồng ý", "Đồng ý")}
        cancelText={t("Huỷ", "Huỷ")}
        onCancel={() => setOpenAddModal(false)}
        footer={null}
        maskClosable={false}
        width={"50vw"}
      >
        <section className="list-type-question">
          {ListTypeQuestion.map((item: any, i: number) => (
            <div className="item-type" key={i + 1}>
              <div className="item-type__title">
                <Typography.Title level={5}>{item.title}</Typography.Title>
              </div>
              <div className="item-type__list">
                <Row gutter={16}>
                  {item.childs.map((itemChild: any, iChild: number) => (
                    <Col span={6} key={iChild + 1}>
                      <div
                        className={`item-type__list__item ${
                          activeType === itemChild.type ? "type-active" : ""
                        } ${itemChild?.disable ? "item-disable" : ""}`}
                        onClick={() => confirmCreateQuestion(itemChild.type)}
                      >
                        <Typography.Paragraph className="title">
                          {itemChild.title}
                        </Typography.Paragraph>
                        <Image
                          preview={false}
                          src={itemChild.image}
                          className="icon"
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          ))}
        </section>
      </Modal>
    </div>
  );
}

export default AddQuestionSidebar;
